// extracted by mini-css-extract-plugin
export default {"PDS_Icon":"Icon_PDS_Icon__ivGuI","bordered":"Icon_bordered__uUt9g"};